import { render } from "./ClientInformation.vue?vue&type=template&id=23f21135"
import script from "./ClientInformation.vue?vue&type=script&lang=js"
export * from "./ClientInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__